import React from "react";
import { Row, Col } from "react-bootstrap";

export default (props) => {
  return (
    <div className="patient_info">
      <Row>
        <Col>Name:</Col>
        <Col>{props.patname}</Col>
      </Row>
      <Row>
        <Col>Phone:</Col>
        <Col>{props.mobile}</Col>
      </Row>
      <Row>
        <Col>Address:</Col>
        <Col>{props.pataddress}</Col>
      </Row>
      <Row>
        <Col>Dr. Name:</Col>
        <Col>Dr. {props.doctorname}</Col>
      </Row>
    </div>
  );
};
